import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

import type { OverlayHookVariant } from "../../types/types";

const BACKGROUND_BY_VARIANT: Record<OverlayHookVariant, string> = {
    horizontal: `linear-gradient(180deg, rgba(239, 239, 255, 0.6) 0%, ${colorsPalettes.indigo[50]} 58.79%)`,
    vertical: `linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, ${colorsPalettes.carbon[0]} 66.67%)`,
};

export const StyledOverlayHook = styled(Flex)<{ height?: number; variant: OverlayHookVariant }>`
    width: 100%;
    height: ${({ height }) => (height ? `${height}px` : "auto")};
    padding: 24px 83px;

    align-items: center;
    flex-direction: ${({ variant }) => (variant === "horizontal" ? "row" : "column")};
    justify-content: ${({ variant }) => (variant === "horizontal" ? "flex-start" : "center")};
    gap: ${({ variant }) => (variant === "horizontal" ? "64px" : "16px")};

    overflow: hidden;
    backdrop-filter: blur(${({ variant }) => (variant === "horizontal" ? 5 : 10)}px);
    background: ${({ variant }) => BACKGROUND_BY_VARIANT[variant]};
`;
